var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21634_45919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.57895 27.2671L0 29H33.8946L30.5666 27.2671H3.57895Z",
    fill: "var(--operator-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9033 3.84227H4.76099V27.8118H29.9033V3.84227Z",
    fill: "#DFF0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3859 27.3222L14.2859 24.1445L29.903 24.1629V27.4228L14.3859 27.3222Z",
    fill: "#94CEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5238 24.4454H14.5269V25.1144H16.5238V24.4454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9958 24.4454H16.958V25.1144H18.9958V24.4454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4679 24.4454H19.4302V25.1144H21.4679V24.4454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9398 24.4454H21.9021V25.1144H23.9398V24.4454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4118 24.4454H24.374V25.1144H26.4118V24.4454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8835 24.4454H26.8457V25.1144H28.8835V24.4454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9032 24.4454H29.3176V25.1144H29.9032V24.4454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3878 25.3151H14.5269V25.984H15.3878V25.3151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8603 25.3151H15.8225V25.984H17.8603V25.3151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3322 25.3151H18.2944V25.984H20.3322V25.3151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8039 25.3151H20.7661V25.984H22.8039V25.3151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2758 25.3151H23.238V25.984H25.2758V25.3151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.748 25.3151H25.7102V25.984H27.748V25.3151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.903 25.3151H28.1819V25.984H29.903V25.3151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5238 26.2185H14.5269V26.8874H16.5238V26.2185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9958 26.2185H16.958V26.8874H18.9958V26.2185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4679 26.2185H19.4302V26.8874H21.4679V26.2185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9398 26.2185H21.9021V26.8874H23.9398V26.2185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4118 26.2185H24.374V26.8874H26.4118V26.2185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8835 26.2185H26.8457V26.8874H28.8835V26.2185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9032 26.2185H29.3176V26.8874H29.9032V26.2185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3878 27.0881H14.5269V27.7571H15.3878V27.0881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8603 27.0881H15.8225V27.7571H17.8603V27.0881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3322 27.0881H18.2944V27.7571H20.3322V27.0881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8039 27.0881H20.7661V27.7571H22.8039V27.0881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2758 27.0881H23.238V27.7571H25.2758V27.0881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.748 27.0881H25.7102V27.7571H27.748V27.0881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2196 27.0881H28.1819V27.7571H30.2196V27.0881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9033 3.84227V5.23302L7.35622 27.8114H4.76099V3.84227H29.9033Z",
    fill: "#94CEBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.9037 4.40466V11.2327C29.4549 11.0924 29.0626 10.8122 28.7839 10.433C28.5053 10.0538 28.3548 9.59546 28.3545 9.12466C28.3545 9.71012 28.1222 10.2716 27.7088 10.6856C27.2954 11.0996 26.7347 11.3322 26.15 11.3322C25.5654 11.3322 25.0046 11.0996 24.5912 10.6856C24.1778 10.2716 23.9456 9.71012 23.9456 9.12466C23.938 9.70509 23.7024 10.2592 23.2899 10.667C22.8773 11.0747 22.321 11.3034 21.7413 11.3034C21.1616 11.3034 20.6052 11.0747 20.1927 10.667C19.7801 10.2592 19.5445 9.70509 19.537 9.12466C19.5294 9.70509 19.2939 10.2592 18.8813 10.667C18.4688 11.0747 17.9124 11.3034 17.3327 11.3034C16.753 11.3034 16.1967 11.0747 15.7841 10.667C15.3715 10.2592 15.136 9.70509 15.1284 9.12466C15.1284 9.71012 14.8962 10.2716 14.4828 10.6856C14.0693 11.0996 13.5086 11.3322 12.924 11.3322C12.3393 11.3322 11.7786 11.0996 11.3652 10.6856C10.9518 10.2716 10.7195 9.71012 10.7195 9.12466C10.7195 9.71012 10.4872 10.2716 10.0738 10.6856C9.6604 11.0996 9.09969 11.3322 8.51503 11.3322C7.93037 11.3322 7.36965 11.0996 6.95623 10.6856C6.54281 10.2716 6.31056 9.71012 6.31056 9.12466C6.31049 9.59558 6.16009 10.0541 5.88131 10.4334C5.60254 10.8126 5.20999 11.0927 4.76099 11.2327V4.40466L5.1038 3.8419H29.5616L29.9037 4.40466Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7704 7.78643H1.89478L4.72866 3.12082L5.60685 1.6753H29.058L29.0981 1.74133L29.1723 1.86326L32.7704 7.78643Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3545 7.78643H6.31055L8.41798 2.92724L8.96123 1.6753H25.7042L25.8593 2.03208L28.3545 7.78643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9458 7.78643H10.719L12.0318 2.74078L12.309 1.6753H22.3558L22.4936 2.20429L23.9458 7.78643Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5364 7.78643H15.1274L15.5811 2.55807L15.6576 1.6753H19.0066L19.0677 2.37949L19.5364 7.78643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10745 9.99394C4.39694 9.99394 4.6836 9.93684 4.95106 9.82591C5.21852 9.71497 5.46154 9.55236 5.66624 9.34738C5.87094 9.14239 6.03332 8.89904 6.14411 8.63122C6.25489 8.36339 6.31192 8.07634 6.31192 7.78645H1.90186C1.90186 8.07643 1.95891 8.36358 2.06977 8.63148C2.18062 8.89938 2.3431 9.14278 2.54793 9.34778C2.75275 9.55278 2.9959 9.71536 3.26349 9.82623C3.53108 9.9371 3.81786 9.99409 4.10745 9.99394Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51502 9.99394C9.09968 9.99394 9.66039 9.76136 10.0738 9.34738C10.4872 8.93339 10.7195 8.37191 10.7195 7.78645H6.31055C6.31065 8.37188 6.54293 8.93331 6.95633 9.34727C7.36973 9.76123 7.93038 9.99384 8.51502 9.99394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9239 9.99394C13.5085 9.99384 14.0692 9.76122 14.4825 9.34725C14.8958 8.93327 15.128 8.37184 15.128 7.78645H10.7195C10.7195 8.37191 10.9517 8.93339 11.3652 9.34738C11.7786 9.76136 12.3393 9.99394 12.9239 9.99394Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3328 9.99394C17.9174 9.99394 18.4781 9.76136 18.8916 9.34738C19.305 8.93339 19.5372 8.37191 19.5372 7.78645H15.1279C15.128 8.37194 15.3604 8.93343 15.7738 9.3474C16.1873 9.76138 16.7481 9.99394 17.3328 9.99394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7413 9.99394C22.3259 9.99384 22.8865 9.76122 23.2999 9.34725C23.7132 8.93327 23.9454 8.37184 23.9454 7.78645H19.5369C19.5369 8.07634 19.5939 8.36339 19.7047 8.63122C19.8155 8.89904 19.9778 9.14239 20.1825 9.34738C20.3872 9.55236 20.6303 9.71497 20.8977 9.82591C21.1652 9.93684 21.4518 9.99394 21.7413 9.99394Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1498 9.99394C26.7344 9.99394 27.2952 9.76136 27.7086 9.34738C28.122 8.93339 28.3542 8.37191 28.3542 7.78645H23.9453C23.9454 8.37188 24.1777 8.93331 24.5911 9.34727C25.0045 9.76123 25.5651 9.99384 26.1498 9.99394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5582 9.99394C31.1428 9.99384 31.7035 9.76123 32.1169 9.34727C32.5303 8.93331 32.7626 8.37188 32.7627 7.78645H28.3545C28.3545 8.37178 28.5866 8.93315 28.9999 9.34712C29.4132 9.76108 29.9737 9.99374 30.5582 9.99394Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.1717 1.86326L25.8583 2.03208L22.4927 2.20429L19.0669 2.37949L15.5826 2.55807L12.0331 2.74078L8.41883 2.92836C6.91684 3.00677 5.64077 3.07355 4.72998 3.12195L5.60592 1.6753H26.7462L29.0971 1.74133L29.1717 1.86326Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.219 1.78561H5.44562L4.76562 0.194519L29.6183 0.261299L29.219 1.78561Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1545 26.9861H3.50952V27.8114H31.1545V26.9861Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72338 26.5006L5.08946 26.5123L5.01978 26.9805H10.553L10.0795 12.9589L6.49179 12.2029L5.2086 13.0688L5.08571 14.2491H5.98489L5.72338 26.5006Z",
    fill: "#DFF0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1865 26.9805L13.8564 13.9929L13.8343 13.1236L7.14524 12.9589L7.11977 14.2491L6.86987 26.9805H14.1865Z",
    fill: "#C8DED8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8343 26.7246H7.14526L7.23031 23.0783L7.46072 13.2421H13.511L13.8122 25.799L13.8343 26.7246Z",
    fill: "var(--operator-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.8122 25.799L9.98402 25.4967L7.23031 23.0783L7.14526 26.7246H13.8343L13.8122 25.799Z",
    fill: "#43927C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73145 26.0737L7.74006 25.6561L7.8105 22.092L7.84384 20.3805L7.90341 17.3637L7.92514 16.263L7.9761 13.6747H13.0107L13.0193 14.9428L13.0268 15.9869L13.0587 20.4371L13.0875 24.4653L13.0984 26.0737H7.73145Z",
    fill: "#94CEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 25.7225H7.95557L7.95669 25.6681L7.9743 24.7801L8.00914 23.0067L8.02675 22.1029L8.06047 20.3917L8.08819 18.9852L8.10468 18.1415L8.11966 17.3746L8.13016 16.8494L8.14177 16.2743L8.16462 15.1202L8.18598 14.0259H12.7969L12.7995 14.4292L12.8032 14.9465L12.8081 15.641L12.8107 15.991L12.8118 16.1302L12.8411 20.2424L12.8426 20.4413L12.8501 21.5022L12.8714 24.4694L12.88 25.7225Z",
    fill: "url(#paint0_linear_21634_45919)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.7994 14.4292L8.13013 16.8494L8.14174 16.2743L8.1646 15.1202C9.01207 14.7687 9.96294 14.374 10.7984 14.0259H12.7968L12.7994 14.4292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.8118 16.1302L8.08813 18.9852L8.10462 18.1415L12.808 15.641L12.8107 15.991L12.8118 16.1302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.8501 21.5023L7.97437 24.7801L8.00921 23.0067L12.8411 20.2424L12.8426 20.4413L12.8501 21.5023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.8564 13.9932L13.5293 14.0071L13.185 14.0214L12.9546 14.0308C12.2023 14.0615 11.4088 14.0938 10.6426 14.1238L9.80002 14.1564C9.15299 14.1812 8.54718 14.2033 8.02903 14.221L7.79787 14.2288L7.43745 14.2401C7.32505 14.2439 7.21828 14.2469 7.12012 14.2495L7.14522 12.9593L13.8343 13.124L13.8564 13.9932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6296 13.3622H6.3396L6.41678 12.7754L6.49171 12.2029L14.4636 12.2945L14.546 12.8235L14.6296 13.3622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6296 13.3622H6.3396L6.41678 12.7754C6.8821 12.8482 7.52613 12.9495 7.55573 12.969C7.60181 12.999 11.9695 13.044 11.9695 13.044L14.546 12.8223L14.6296 13.3622Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.189 14.8415L15.5887 23.9438L27.4136 24.044L27.9171 14.5999L15.189 14.8415Z",
    fill: "#DFF0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.418 13.3622L28.3899 13.8863L27.9144 22.8063L16.0896 22.7061L15.7528 15.0313L15.6902 13.6038L28.418 13.3622Z",
    fill: "var(--operator-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9035 13.8537L27.8492 15.0426L27.8226 15.6234L27.6113 20.2394L27.5506 21.5619L27.5139 22.3715L26.1295 22.3464L23.964 22.3066L18.2389 22.2016L17.185 22.1821L16.5908 22.1712L16.523 20.7849L16.4657 19.6133L16.3874 18.0098L16.3406 17.0531L16.2727 15.6695L16.1899 13.9756L20.0444 13.9358L22.3616 13.9115L24.13 13.8931L25.9119 13.8743L27.7746 13.8552L27.9035 13.8537Z",
    fill: "url(#paint1_linear_21634_45919)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0444 13.9358L16.2727 15.6695L16.3405 17.0531L22.3616 13.9115L20.0444 13.9358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1301 13.8931C22.1968 14.9259 18.5578 16.867 16.3875 18.0098L16.4658 19.6133L25.9123 13.8732L24.1301 13.8931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5139 22.3715L27.5513 21.5619L26.1299 22.3464L27.5139 22.3715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9641 22.3066L27.6114 20.2394L27.8227 15.6233L18.239 22.2016L23.9641 22.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7746 13.8552L16.5229 20.7849L16.5908 22.1712L17.185 22.182L27.8491 15.0426L27.9035 13.8537L27.7746 13.8552Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.418 13.3622L28.3899 13.8863L15.7528 15.0313L15.6902 13.6038L28.418 13.3622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0503 12.5376L28.8955 13.235L28.8498 13.4406L15.0554 13.6368V12.7754L29.0503 12.5376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8955 13.235L28.8498 13.4406L15.0554 13.6368V13.0917L28.8955 13.235Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21634_45919",
    x1: 10.4178,
    y1: 26.3082,
    x2: 10.4178,
    y2: 13.4417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#347561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FC1C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21634_45919",
    x1: 22.0465,
    y1: 13.7216,
    x2: 22.0465,
    y2: 22.2676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367F6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EB6B6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21634_45919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.42338ae153fc306f5eefabdad1756d23.svg";
export { ForwardRef as ReactComponent };